// src/pages/exercise/components/UI/ExerciseCompletePopup.jsx
import { useEffect, useState } from 'react';
import './ExerciseCompletePopup.css';

export function ExerciseCompletePopup({ onClose }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const id = requestAnimationFrame(() => setMounted(true));
    return () => cancelAnimationFrame(id);
  }, []);

  const handleClose = () => {
    setMounted(false);
    setTimeout(onClose, 500);
  };

  return (
    <div
      className={`ecp-root${mounted ? ' ecp-root--visible' : ''}`}
      onClick={handleClose}
    >
      <div className="ecp-content" onClick={(e) => e.stopPropagation()}>

        <p className="ecp-eyebrow">Well done</p>

        <div
          className="ecp-headline-wrap"
          data-text="Every rep was worth it."
        >
          <h1 className="ecp-headline">Every rep was worth it.</h1>
        </div>

        <div className="ecp-rule" />

        <p className="ecp-body">Today's work is done.</p>

        <p className="ecp-sub">Come back tomorrow — your body will remember this.</p>

        <button className="ecp-close" onClick={handleClose}>
          Close
        </button>

      </div>
    </div>
  );
}